import React, { useEffect, useState } from "react";

function LetterAnimation({ letter, speed }) {
  const [dust, setDust] = useState([]);

  useEffect(() => {
    if (letter) {
      const interval = setInterval(() => {
        setDust((prev) => [...prev, Date.now()]);
      }, 300);
      return () => clearInterval(interval);
    }
  }, [letter]);

  const animationDuration = speed === "slow" ? "3s" : speed === "medium" ? "2s" : "1s";

  return (
    <div className="letter-area" style={{ position: "relative" }}>
      <svg viewBox="0 0 100 100" className="letter-svg">
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fontSize="60"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeDasharray="300"
          strokeDashoffset="300"
          style={{ animation: `draw ${animationDuration} linear forwards` }}
        >
          {letter}
        </text>
      </svg>
      {dust.map((id) => (
        <div key={id} className="chalk-dust" style={{ left: `${50 + Math.random()*50}px`, top: `${50 + Math.random()*50}px` }} />
      ))}
    </div>
  );
}

export default LetterAnimation;
